// extracted by mini-css-extract-plugin
export default {"Container":"MinimizedPanelsContainer_Container__6sDg4","PanelWrapper":"MinimizedPanelsContainer_PanelWrapper__GzfgS"};